/* =========================================================
   Spanish Kitchen · Guided Cooking
   Recipe Footer Share Actions
   ========================================================= */

(function () {
  "use strict";

  function getShareData() {
    var recipeTitle =
      document.querySelector("h1")?.textContent?.trim() ||
      document.title ||
      "Spanish Kitchen Recipe";

    var recipeUrl = window.location.href.split("#")[0];

    return {
      title: recipeTitle,
      url: recipeUrl,
      message: recipeTitle + " — " + recipeUrl
    };
  }

  function copyText(text) {
    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function" &&
      window.isSecureContext
    ) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var temporaryTextarea = document.createElement("textarea");

      temporaryTextarea.value = text;
      temporaryTextarea.setAttribute("readonly", "");
      temporaryTextarea.style.position = "fixed";
      temporaryTextarea.style.top = "-9999px";
      temporaryTextarea.style.left = "-9999px";
      temporaryTextarea.style.opacity = "0";

      document.body.appendChild(temporaryTextarea);

      temporaryTextarea.focus();
      temporaryTextarea.select();

      try {
        var successful = document.execCommand("copy");

        document.body.removeChild(temporaryTextarea);

        if (successful) {
          resolve();
        } else {
          reject(new Error("Copy command failed."));
        }
      } catch (error) {
        document.body.removeChild(temporaryTextarea);
        reject(error);
      }
    });
  }

  function showTemporaryButtonText(button, temporaryText, originalText) {
    button.textContent = temporaryText;

    window.setTimeout(function () {
      button.textContent = originalText;
    }, 2200);
  }

  function initialiseFooter(footer) {
    if (!footer || footer.dataset.skgcInitialised === "true") {
      return;
    }

    footer.dataset.skgcInitialised = "true";

    var whatsappButton = footer.querySelector(".skgc-share-whatsapp");
    var emailButton = footer.querySelector(".skgc-share-email");
    var copyButton = footer.querySelector(".skgc-share-copy");

    if (whatsappButton) {
      whatsappButton.setAttribute("type", "button");
      whatsappButton.setAttribute(
        "aria-label",
        "Share this recipe on WhatsApp"
      );

      whatsappButton.addEventListener("click", function () {
        var share = getShareData();

        var whatsappUrl =
          "https://wa.me/?text=" + encodeURIComponent(share.message);

        window.open(whatsappUrl, "_blank", "noopener,noreferrer");
      });
    }

    if (emailButton) {
      emailButton.setAttribute("type", "button");
      emailButton.setAttribute(
        "aria-label",
        "Share this recipe by email"
      );

      emailButton.addEventListener("click", function () {
        var share = getShareData();

        var subject = "Spanish Kitchen recipe: " + share.title;

        var body =
          "I thought you might enjoy this Spanish Kitchen recipe:\n\n" +
          share.title +
          "\n" +
          share.url;

        window.location.href =
          "mailto:?subject=" +
          encodeURIComponent(subject) +
          "&body=" +
          encodeURIComponent(body);
      });
    }

    if (copyButton) {
      copyButton.setAttribute("type", "button");
      copyButton.setAttribute(
        "aria-label",
        "Copy the recipe link"
      );

      var originalText = copyButton.textContent.trim() || "Copy Link";

      copyButton.addEventListener("click", function () {
        var share = getShareData();

        copyText(share.url)
          .then(function () {
            copyButton.classList.add("is-copied");
            showTemporaryButtonText(
              copyButton,
              "Link Copied",
              originalText
            );

            window.setTimeout(function () {
              copyButton.classList.remove("is-copied");
            }, 2200);
          })
          .catch(function () {
            showTemporaryButtonText(
              copyButton,
              "Unable to Copy",
              originalText
            );
          });
      });
    }
  }

  function initialiseAllFooters() {
    var footers = document.querySelectorAll(".skgc-footer");

    footers.forEach(function (footer) {
      initialiseFooter(footer);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseAllFooters
    );
  } else {
    initialiseAllFooters();
  }

  document.addEventListener(
    "shopify:section:load",
    initialiseAllFooters
  );
})();